import { Component, inject, Optional, signal } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { EntryService } from '../../entry.service';
import { GoogleAnalyticsService } from 'src/app/google-analytics.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { EntrySelectors } from 'src/app/state/entry.selectors';
import { Store } from '@ngrx/store';
import { EntryData, PlddtData } from '../../structure-data.models';
import { filter, tap } from 'rxjs';
import { PlatformService } from 'src/app/platform.service';

@Component({
  selector: 'app-model-confidence',
  templateUrl: './model-confidence.component.html',
  styleUrl: './model-confidence.component.css',
  standalone: false
})
export class ModelConfidenceComponent {
  public expanded = signal<boolean>(false);
  private entryService = inject(EntryService);
  public accession = toSignal(this.store.select(EntrySelectors.accession));
  // public entryData = toSignal(this.store.select(EntrySelectors.entryData));
  public entryData = signal<EntryData>({} as EntryData);
  public tedDomainData = toSignal(
    this.store.select(EntrySelectors.tedDomainData)
  );
  public csvAmData = toSignal(this.store.select(EntrySelectors.csvAmData));
  public averageplddtDisplay:string;

  public hydrationReady: boolean = false;
  constructor(
    @Optional()
    private store: Store,
    private platform: PlatformService,
    public bottomSheetRef: MatBottomSheetRef<ModelConfidenceComponent>,
    public gaService: GoogleAnalyticsService,
  ) {}
  public plddtData: PlddtData;
  public selectedTabName = this.entryService.selectedTabName;
  private selectedComponent = this.entryService.selectedComponent;

  ngOnInit(): void {
    this.store
      .select(EntrySelectors.entryData)
      .pipe(
        filter(Boolean),
        tap((data) => {
          return this.entryData.set(data);
        })
      )
      .subscribe(() => { 
        if (this.entryData().globalMetricValue) {
          this.averageplddtDisplay = this.entryData().globalMetricValue
            ? `${this.entryData().globalMetricValue} (${this.getPlddtLevel(
              this.entryData().globalMetricValue
              )})` : "";
        }

        if (
          this.entryData().fractionPlddtVeryLow ||
          this.entryData().fractionPlddtLow ||
          this.entryData().fractionPlddtConfident ||
          this.entryData().fractionPlddtVeryHigh
        ) {
          this.plddtData = {
            fractionPlddtVeryLow: this.entryData().fractionPlddtVeryLow,
            fractionPlddtLow: this.entryData().fractionPlddtLow,
            fractionPlddtConfident: this.entryData().fractionPlddtConfident,
            fractionPlddtVeryHigh: this.entryData().fractionPlddtVeryHigh,
          };
        }

      });
    if (this.platform.isBrowserPlatform()) {
      this.hydrationReady = true;
    }
  }
  formatPercentage(value: number | undefined | null): string {
    if (value == null) return '0.0';
    return (value * 100).toFixed(1);
  }
  public getPlddtLevel(plddt: number): string {
    return plddt > 90
      ? 'Very High'
      : plddt > 70
      ? 'High'
      : plddt > 50
      ? 'Low'
      : 'Very Low';
  }
  public closeBottomSheet(): void {
    this.bottomSheetRef.dismiss();
    this.entryService.updateSelectedComponent(null);
    this.entryService.updateSelectedTabName('');
  }

  public toggleBottomsheetHeight(): void {
    this.expanded.update((olamide) => !olamide);
    const container = document.querySelector(
      '.custom-bottom-sheet'
    ) as HTMLElement;
    if (container) {
      container.style.height = this.expanded() ? '50%' : '10%';
    }
    //for GA tag
    let tag = "bottomsheet_toggle_up";
    let gtagmsg = "Opening bottomsheet up";
    if(!this.expanded()){
      tag = "bottomsheet_toggle_down";
      gtagmsg = "Collapsing bottomsheet down";
    }
    this.gaService.eventEmitter('bottomsheet_toggle', 'mobile_overlay_interaction', 'tap', tag, gtagmsg);
  }
}
